$(function() {
  $(".checkBoxBtn").on("click",function(){
    let questionField = $(this).parent().parent().parent();
    requiredCheckbox(questionField);
  });

  $('.arrayOther').on('click',function(){
    let questionField = $(this).parent().parent();
    requiredCheckbox(questionField);
  });

  function requiredCheckbox(questionField) {
    if ($(questionField).attr("class") == "requiredQuestion") {
      let checkedCnt = $(questionField).find(".checkBoxBtn:checked").length;
      $(questionField).find(".checkBoxBtn").each(function(i, checkBox){
        if (checkedCnt > 0) {
          $(checkBox).prop("required", false);
        } else {
          $(checkBox).prop("required", true);
        }
      });
    }
  };
});
